module.exports = __webpack_public_path__ + "static/img/code.a81a3a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/code.png
// module id = 4U2k
// module chunks = 27